module.exports = __webpack_public_path__ + "img/icon3.b758e672.svg";